import { Fragment } from "react/jsx-runtime";
import { usePopover } from "../../store/usePopoverStore"

export const GlobalPopoverRenderer = () => {
  const popovers = usePopover();
  const popPopover = usePopover((state) => state.popPopover);

  return (
    <>
      {popovers.map(({ id, Popover: PopoverComponent, anchorEl, props, child }) => (
        <Fragment key={id}>
          <PopoverComponent
            {...props}
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onClose={() => popPopover(id)}
          >
            {child}
          </PopoverComponent>
        </Fragment>
      ))}
    </>
  );
}